import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SET_SELECTED_GROUP, VULNERABILITY_ID, GET_CVE_IDS, SET_SELECTED_LABEL, SET_SITEMAP_EXPAND_ACCORDION, SET_NETSPACE_LOADER } from "./NetSpaceConstant";
import Page_Loader from "../../assets/vizr_images/page_loader.gif";
import { Grid, Box } from "material-ui-core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { StyledCardHeader } from "./NetSpaceUtils";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import styled from "styled-components";

export const CustomCard = styled(Card)(({ color }) => ({
  backgroundColor: color,
  borderRadius: "5px",
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
  width: "100%",
  fontWeight: "bold",
  height: "250.34px",
  minWidth: "280px",
  transition: "box-shadow 0.3s ease, transform 0.3s ease", // smooth transition
  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",

  "@media (max-width: 1600px)": {
    height: "220px",
    minWidth: "255px",
  },
  "@media (max-width: 1800px)": {
    height: "210px",
    minWidth: "250px",
  },

  "&:hover": {
    boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
    transform: "translateY(-2px)", // optional: subtle lift on hover
    cursor: "pointer",
  },
}));

function CVEIDByHost() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: GET_CVE_IDS,
    });
  }, []);

  const cveIds = useSelector((state) => state.NetspaceReducer?.cveIdsDashboard);
  const loader = useSelector((state) => state.NetspaceReducer.loader);
  const reduxSelectedLabel = useSelector(
        (state) => state.NetspaceReducer?.selectedLabel,
      );

  // Convert CVE object to sorted array: [{ name: CVEID, value: count }]
  const chartData = Object.entries(cveIds || {})
    .map(([cveid, count]) => ({
      name: cveid,
      value: count,
    }))
    .sort((a, b) => b.value - a.value) // Descending order by count
    .slice(0, 5); // Optional: top 5 CVEs

  const renderContent = () => {
    if (!chartData.length) return <div>No data available</div>;

    return (
      <Box sx={{ width: "100%", height: 250 }}>
        <ResponsiveContainer width="100%" height="65%">
          <BarChart
            layout="vertical"
            data={chartData}
            margin={{ top: 0, right: 20, bottom: 10, left: 10 }}
            barCategoryGap={0}
            barGap={0}
          >
            <XAxis type="number" tick={{ fontSize: 10 }} />
            <YAxis
              dataKey="name"
              type="category"
              width={80}
              tick={{ fontSize: 10 }}
            />
            <Tooltip
              formatter={(value) => [`${value} host(s)`, "Vulnerability ID"]}
              wrapperClassName="custom-tooltip"
            />
            <Bar
              dataKey="value"
              fill="#3366FF"
              radius={[0, 4, 4, 0]}
              style={{cursor: "pointer"}}
              barSize={15}
              onClick={(data) => {
                const clickedCve = data?.name;
                const isSameLabel = reduxSelectedLabel === clickedCve;
                dispatch({ type: SET_NETSPACE_LOADER, payload: true })
                 dispatch({
                    type: SET_SITEMAP_EXPAND_ACCORDION,
                    payload: {},
                  });

                if (isSameLabel) {
                  dispatch({
                    type: SET_SELECTED_LABEL,
                    payload: null,
                  });

                  dispatch({
                    type: SET_SITEMAP_EXPAND_ACCORDION,
                    payload: {},
                  });

                  return;
                }
                dispatch({
                  type: SET_SELECTED_GROUP,
                  payload: {
                    group: "VULNERABILITY_ID",
                    place: "non-widget",
                  },
                });

                dispatch({
                  type: SET_SELECTED_LABEL,
                  payload: clickedCve,
                });
              }}
            >
              <LabelList
                dataKey="value"
                position="right"
                style={{ fontSize: 10 }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    );
  };

  return (
    <Grid item xs={3}>
      <CustomCard color="white">
        <StyledCardHeader title="Vulnerability ID by Host Count" />
        <CardContent className="card-content">{renderContent()}</CardContent>
      </CustomCard>
    </Grid>
  );
}

export default CVEIDByHost;
